// extracted by mini-css-extract-plugin
export default {"mainProizvodi":"Products_mainProizvodi__8-tvj","holderProizvodi":"Products_holderProizvodi__V7x4Q","proizvod":"Products_proizvod__6oWtx","naziv":"Products_naziv__V0aPH"};